import React from "react";
import "./ManageSubscriptionModal.scss";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalScroller,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import SubscriptionStylingProvider from "../../components/SubscriptionStylingProvider/SubscriptionStylingProvider";

interface Props {
  onClose: () => void;
}

function ManageSubscriptionModal(props: Props) {
  const { onClose } = props;

  return (
    <Modal
      className="manage-subscription-modal"
      onClose={onClose}
      closeButtonText={
        <IDHFormattedMessage id="ws_close" defaultMessage="Close" />
      }
      displayCancelButton
      closeButtonVariant="white-with-border"
      outsideClick={OutsideClickModes.Warn}
    >
      <ModalTitle>
        <IDHFormattedMessage id="ws_plans" defaultMessage="Plans" />
      </ModalTitle>

      <ModalScroller maxHeight={647}>
        <SubscriptionStylingProvider
          sectionStylingModes={{ paywall: "indahash" }}
        >
          No manage subscription screen available
        </SubscriptionStylingProvider>
      </ModalScroller>
    </Modal>
  );
}

export default ManageSubscriptionModal;
